import Vue from 'vue';
import VueRouter from 'vue-router';

import Assignments from '@/views/Assignments.vue';
import Home from '@/views/Home.vue';
import Login from '@/views/Login.vue';
import Logout from '@/views/Logout.vue';
import ProblemDetail from '@/views/ProblemDetail.vue';
import ProblemList from '@/views/ProblemList.vue';
import Scoreboard from '@/views/Scoreboard.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: 'Login to Teary',
    },
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout,
    meta: {
      title: 'Logging out...',
    },
  },
  {
    path: '/assignments',
    name: 'assignments',
    component: Assignments,
    meta: {
      title: 'Assignments',
    },
  },
  {
    path: '/assignments/:assignment_id',
    name: 'problem_list',
    component: ProblemList,
    meta: {
      title: 'Problem List',
    },
  },
  {
    path: '/assignments/:assignment_id/scoreboard',
    name: 'scoreboard',
    component: Scoreboard,
    meta: {
      title: 'Scoreboard',
    },
  },
  {
    path: '/problems/:problem_id',
    name: 'problem_detail',
    component: ProblemDetail,
    meta: {
      title: 'Problem Detail',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
